/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type * as Types from '../../../__generated__/zeus/types';

import type { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
/** Whether the customer account can enter account-gated experiences. */
export type AccountAccessStatus =
  /** Access is restricted pending review or additional verification. */
  | 'FLAGGED'
  /** The account has not completed the checks required for account-gated access. */
  | 'UNVERIFIED'
  /** The account passed the checks required for account-gated access. */
  | 'VERIFIED';

/** Listing and requested time for a new home tour appointment. */
export type BuyerTourCreateInput = {
  /** Requested tour date in the listing’s local calendar. */
  appointmentDate: Types.Scalars['NonEmptyString']['input'];
  /** Requested tour start time in the listing’s local time. */
  appointmentTime: Types.Scalars['NonEmptyString']['input'];
  /** Requested tour duration in minutes; defaults to 30 and cannot exceed 1,440. */
  durationMinutes?: Types.Scalars['SafeInt']['input'] | null | undefined;
  /** Listing to tour. */
  listingId: Types.Scalars['NonEmptyString']['input'];
};

/** Primary phone number to save for the authenticated customer. */
export type CustomerPrimaryPhoneNumberUpdateInput = {
  /** Replacement primary phone number for the customer. */
  phoneNumber: Types.Scalars['PhoneNumber']['input'];
};

/** Listing and search window for tour availability. */
export type TourAvailabilityInput = {
  /** Number of calendar days to search; defaults to 5 and cannot exceed 30. */
  daysOut?: Types.Scalars['SafeInt']['input'] | null | undefined;
  /** Requested tour duration in minutes; defaults to 30 and cannot exceed 1,440. */
  durationMinutes?: Types.Scalars['SafeInt']['input'] | null | undefined;
  /** Listing whose tour availability is requested. */
  listingId: Types.Scalars['NonEmptyString']['input'];
};

export type TourAppointmentFieldsFragment = { id: Types.Scalars['ID']['output'], addressId: Types.Scalars['UUID']['output'] | null, listingId: Types.Scalars['NonEmptyString']['output'] | null, scheduledFor: Types.Scalars['DateTime']['output'] | null, endTime: Types.Scalars['DateTime']['output'] | null, timezone: Types.Scalars['TimeZone']['output'] | null, readableAddress: Types.Scalars['NonEmptyString']['output'] | null, listing: { addressId: Types.Scalars['UUID']['output'], slug: Types.Scalars['String']['output'] | null, street: Types.Scalars['String']['output'] | null, city: Types.Scalars['String']['output'] | null, state: Types.Scalars['String']['output'] | null, postalCode: Types.Scalars['PostalCode']['output'] | null, photoUrls: Array<Types.Scalars['URL']['output']> } | null };

export type TourAvailabilityQueryVariables = Exact<{
  input: Types.TourAvailabilityInput;
}>;


export type TourAvailabilityQuery = { tours: { availability: { availableNow: Types.Scalars['Boolean']['output'], timezone: Types.Scalars['TimeZone']['output'] | null, nextAvailable: { startTime: Types.Scalars['DateTime']['output'], endTime: Types.Scalars['DateTime']['output'], isNow: Types.Scalars['Boolean']['output'] } | null, days: Array<{ date: Types.Scalars['Date']['output'], slots: Array<{ startTime: Types.Scalars['DateTime']['output'], endTime: Types.Scalars['DateTime']['output'], isNow: Types.Scalars['Boolean']['output'] }> }> } } };

export type BuyerTourCreateMutationVariables = Exact<{
  input: Types.BuyerTourCreateInput;
}>;


export type BuyerTourCreateMutation = { buyerTourCreate:
    | { __typename: 'InvalidInputError', code: Types.Scalars['String']['output'] }
    | { __typename: 'NotFoundError', code: Types.Scalars['String']['output'] }
    | { __typename: 'TourAppointment', id: Types.Scalars['ID']['output'], addressId: Types.Scalars['UUID']['output'] | null, listingId: Types.Scalars['NonEmptyString']['output'] | null, scheduledFor: Types.Scalars['DateTime']['output'] | null, endTime: Types.Scalars['DateTime']['output'] | null, timezone: Types.Scalars['TimeZone']['output'] | null, readableAddress: Types.Scalars['NonEmptyString']['output'] | null, listing: { addressId: Types.Scalars['UUID']['output'], slug: Types.Scalars['String']['output'] | null, street: Types.Scalars['String']['output'] | null, city: Types.Scalars['String']['output'] | null, state: Types.Scalars['String']['output'] | null, postalCode: Types.Scalars['PostalCode']['output'] | null, photoUrls: Array<Types.Scalars['URL']['output']> } | null }
    | { __typename: 'UnauthorizedError', code: Types.Scalars['String']['output'] }
   };

export type ViewerTourEligibilityQueryVariables = Exact<{ [key: string]: never; }>;


export type ViewerTourEligibilityQuery = { viewer: { isAuthenticated: Types.Scalars['Boolean']['output'], accountStatus: { access: Types.AccountAccessStatus }, customer: { primaryPhoneNumber: Types.Scalars['PhoneNumber']['output'] | null } | null } };

export type CustomerPrimaryPhoneNumberUpdateMutationVariables = Exact<{
  input: Types.CustomerPrimaryPhoneNumberUpdateInput;
}>;


export type CustomerPrimaryPhoneNumberUpdateMutation = { customerPrimaryPhoneNumberUpdate:
    | { __typename: 'Customer', id: Types.Scalars['ID']['output'] }
    | { __typename: 'InvalidInputError', code: Types.Scalars['String']['output'] }
    | { __typename: 'NotFoundError', code: Types.Scalars['String']['output'] }
    | { __typename: 'UnauthorizedError', code: Types.Scalars['String']['output'] }
   };

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}
export const TourAppointmentFieldsFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment TourAppointmentFields on TourAppointment {
  id
  addressId
  listingId
  scheduledFor
  endTime
  timezone
  readableAddress
  listing {
    addressId
    slug
    street
    city
    state
    postalCode
    photoUrls(first: 1)
  }
}
    `, {"fragmentName":"TourAppointmentFields"}) as unknown as TypedDocumentString<TourAppointmentFieldsFragment, unknown>;
export const TourAvailabilityDocument = /*#__PURE__*/ new TypedDocumentString(`
    query TourAvailability($input: TourAvailabilityInput!) {
  tours {
    availability(input: $input) {
      availableNow
      timezone
      nextAvailable {
        startTime
        endTime
        isNow
      }
      days {
        date
        slots {
          startTime
          endTime
          isNow
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<TourAvailabilityQuery, TourAvailabilityQueryVariables>;
export const BuyerTourCreateDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation BuyerTourCreate($input: BuyerTourCreateInput!) {
  buyerTourCreate(input: $input) {
    __typename
    ...TourAppointmentFields
    ... on Error {
      code
    }
  }
}
    fragment TourAppointmentFields on TourAppointment {
  id
  addressId
  listingId
  scheduledFor
  endTime
  timezone
  readableAddress
  listing {
    addressId
    slug
    street
    city
    state
    postalCode
    photoUrls(first: 1)
  }
}`) as unknown as TypedDocumentString<BuyerTourCreateMutation, BuyerTourCreateMutationVariables>;
export const ViewerTourEligibilityDocument = /*#__PURE__*/ new TypedDocumentString(`
    query ViewerTourEligibility {
  viewer {
    isAuthenticated
    accountStatus {
      access
    }
    customer {
      primaryPhoneNumber
    }
  }
}
    `) as unknown as TypedDocumentString<ViewerTourEligibilityQuery, ViewerTourEligibilityQueryVariables>;
export const CustomerPrimaryPhoneNumberUpdateDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation CustomerPrimaryPhoneNumberUpdate($input: CustomerPrimaryPhoneNumberUpdateInput!) {
  customerPrimaryPhoneNumberUpdate(input: $input) {
    __typename
    ... on Customer {
      id
    }
    ... on Error {
      code
    }
  }
}
    `) as unknown as TypedDocumentString<CustomerPrimaryPhoneNumberUpdateMutation, CustomerPrimaryPhoneNumberUpdateMutationVariables>;